import { ArrowRight, Sparkles } from "lucide-react";
import { Link } from "react-router-dom";

import { ProductCard } from "../components/ProductCard";
import { ErrorPanel, Loading } from "../components/States";
import { useStorefront } from "../components/SiteShell";
import { money } from "../lib/types";

export function HomePage() {
  const { data, isLoading, error } = useStorefront();
  if (isLoading) return <Loading />;
  if (error || !data) return <ErrorPanel />;
  const products = data.featured_products.length ? data.featured_products : data.newest_products;
  return (
    <>
      <section className={`hero ${data.settings.hero_image_url ? "with-photo" : "brand-only"}`}>
        <div className="hero-copy">
          <p className="eyebrow"><Sparkles /> {data.settings.hero_eyebrow}</p>
          <h1>{data.settings.hero_headline}</h1>
          <p>{data.settings.hero_body}</p>
          <div className="hero-actions"><Link className="button primary" to="/shop">Shop the collection <ArrowRight /></Link><Link className="button ghost" to="/contact">Say hello</Link></div>
        </div>
        {data.settings.hero_image_url ? <img src={data.settings.hero_image_url} alt="A handmade Anne Cosette piece" /> : <div className="hero-art" aria-hidden="true"><span>made</span><strong>with</strong><em>joy!</em></div>}
      </section>

      <section className="ticker" aria-label="Store benefits"><span>Made to order</span><i>✿</i><span>Small-batch joy</span><i>✿</i><span>Free shipping over {money(data.settings.free_shipping_threshold_cents)}</span></section>

      <section className="section category-section">
        <div className="section-heading"><p className="eyebrow">Pick your favorite</p><h2>What are we making?</h2></div>
        <div className="category-grid">
          {data.categories.map((category, index) => <Link className={`category-tile color-${index % 3}`} to={`/shop/${category.slug}`} key={category.id}><span>0{index + 1}</span><h3>{category.name}</h3><p>{category.description}</p><ArrowRight /></Link>)}
        </div>
      </section>

      <section className="section product-section">
        <div className="section-heading split"><div><p className="eyebrow">Fresh from the sewing table</p><h2>{data.featured_products.length ? "Anne’s favorites" : "The first pieces are coming"}</h2></div><Link to="/shop">Shop all <ArrowRight /></Link></div>
        {products.length ? <div className="product-grid">{products.map((product) => <ProductCard key={product.id} product={product} />)}</div> : <div className="catalog-empty"><div className="empty-swatch" aria-hidden="true"><span /><span /><span /></div><h3>Anne’s collection is taking shape.</h3><p>Real handmade pieces will appear here as soon as Anne photographs and publishes them.</p></div>}
      </section>

      <section className="story-section">
        <div className="story-image">{data.settings.story_image_url ? <img src={data.settings.story_image_url} alt="Anne Cosette in her creative space" /> : <div className="story-placeholder"><span>Cut</span><span>Sew</span><span>Play</span></div>}</div>
        <div className="story-copy"><p className="eyebrow">Meet the maker</p><h2>{data.settings.story_title}</h2>{data.settings.story_body.split("\n").map((line) => <p key={line}>{line}</p>)}<Link className="button dark" to="/contact">Send Anne a note</Link></div>
      </section>

      <section className="shipping-callout"><span>✿</span><div><p className="eyebrow">Worth the little wait</p><h2>{data.settings.shipping_message}</h2></div><Link to="/shipping">How shipping works <ArrowRight /></Link></section>
    </>
  );
}

